import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import moment from 'moment';
import { Segment, Dimmer, Loader, Header, Table } from 'semantic-ui-react';
import { Role } from '../../roles';
import { Auth, Nav } from '../../components';

function displayLocationName(location) {
  let returnVal;
  if (location.extra_data) {
    if (location.extra_data?.name) {
      return location.extra_data.name;
    }
    returnVal = location.brand_name;
    if (!returnVal || ['unknown', 'unbranded'].includes(returnVal.toLowerCase())) {
      returnVal = location.dealer_name;
    }
  }
  return returnVal;
}

function fuelItem(tx) {
  return tx.extra_data?.line_items?.find(i => i.unit === 'gallon');
}

function LocationDetail({ data }) {
  return (
    <Segment>
      <Dimmer active={!data?.locations}>
        <Loader />
      </Dimmer>
      {data?.locations?.map(l => (
        <React.Fragment>
          <Header>
            Wex Station #
            {l.internal_location_name}
          </Header>
          <Segment attached>
            <div>
              <b>Station Name for Receipts: </b>
              {displayLocationName(l)}
            </div>
            <div>
              <b>Brand/Dealer/Station Name: </b>
              {`${l.brand_name} / ${l.dealer_name} / ${l.location_name}`}
            </div>
            <div>{`Address: ${l.street1} ${l.street2 || ''}, ${l.locality} ${l.region} ${l.postal_code}`}</div>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Tx Date</Table.HeaderCell>
                  <Table.HeaderCell>Tx Id</Table.HeaderCell>
                  <Table.HeaderCell>Account</Table.HeaderCell>
                  <Table.HeaderCell>Fuel Type</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Qty</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {(l.transactions || []).map(tx => (
                  <Table.Row key={tx.transaction_id}>
                    <Table.Cell>{moment(tx.created).format('MM/DD \'YY HH:mm TZ')}</Table.Cell>
                    <Table.Cell><a href={`/payments/transaction/${tx.account_id}/${tx.transaction_id}`}>{tx.transaction_id}</a></Table.Cell>
                    <Table.Cell><a href={`/identity/users/${tx.account_id}`}>{tx.account_id}</a></Table.Cell>
                    <Table.Cell>{fuelItem(tx)?.name}</Table.Cell>
                    <Table.Cell>{fuelItem(tx)?.unit_price}</Table.Cell>
                    <Table.Cell>{fuelItem(tx)?.quantity}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Segment>
        </React.Fragment>
      ))}
    </Segment>
  );
}

LocationDetail.propTypes = {
  data: PT.shape({ locations: PT.array }),
};

LocationDetail.defaultProps = {
  data: null,
};

export const Location = withRouter(({ match }) => (
  <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
    <Nav>
      <WithData url={`/payments/location/${match.params.poiId}`}>
        <LocationDetail />
      </WithData>
    </Nav>
  </Auth>
));

Location.propTypes = {
  match: PT.shape({ params: PT.shape({ poiId: PT.number.isRequired }).isRequired }).isRequired,
};
